const SESSION_KEY = 'session';

export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(SESSION_KEY);
}

export function setToken(token: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(SESSION_KEY, token);
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(SESSION_KEY);
}

export function isAuthenticated(): boolean {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1] ?? '{}'));
    const exp = payload.exp as number | undefined;
    if (exp && exp * 1000 > Date.now()) return true;
  } catch {
    // ignore
  }
  clearSession();
  return false;
}
